import { root, id } from './urls';

export const urls = {
  ...root,
  id,
};
